"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _routing = require("@engaging-tech/routing");
var _components = require("@engaging-tech/components");
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var ButtonText = (0, _styledComponents["default"])(_components.Text).withConfig({
  displayName: "AuxillaryLinks__ButtonText",
  componentId: "sc-1s9nc8d-0"
})(["text-transform:capitalize;"]);

/**
 * Circular separator to add space between account routes and
 * auxillary routes.
 * @package
 */
var Circle = function Circle() {
  return /*#__PURE__*/_react["default"].createElement(_components.Box, {
    width: 8,
    height: 8,
    bg: "rgba(0, 0, 0, 0.16)",
    ml: 3,
    mr: 2,
    borderRadius: 99
  });
};

/**
 * A link for an individual auxillary route.
 * @param {object} props props passed into component
 * @param {object} props.route An auxillary route.
 * @package
 */
var AuxillaryLink = function AuxillaryLink(_ref) {
  var route = _ref.route;
  return /*#__PURE__*/_react["default"].createElement(_routing.Link, (0, _extends2["default"])({
    to: route.path
  }, route.linkProps), /*#__PURE__*/_react["default"].createElement(_components.Button, {
    variant: "light.0",
    borderRadius: 99,
    elevation: 0
  }, /*#__PURE__*/_react["default"].createElement(ButtonText, {
    color: "textPrimary.0",
    fontWeight: "400",
    fontSize: 3
  }, route.description)));
};

/**
 * Links for auxillary routes. This component is **desktop-only**.
 * @package
 */
var AuxillaryLinks = function AuxillaryLinks() {
  var _useNavContext = (0, _useNavContext2["default"])(),
    auxillaryRoutes = _useNavContext.auxillaryRoutes,
    accountRoutes = _useNavContext.accountRoutes;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, auxillaryRoutes.length > 0 && accountRoutes.length > 0 && /*#__PURE__*/_react["default"].createElement(Circle, null), auxillaryRoutes.length > 0 && auxillaryRoutes.map(function (route) {
    return /*#__PURE__*/_react["default"].createElement(AuxillaryLink, {
      key: route.description,
      route: route
    });
  }));
};
var _default = exports["default"] = AuxillaryLinks;